import { BaseReactiveClass } from 'Classes/BaseReactiveClass';
import * as walletApi from 'Api/wallet';
import { ModelAccountWalletBeneficialOwnersItem } from './ModelAccountWalletBeneficialOwnersItem';

export class ModelAccountWalletBeneficialOwners extends BaseReactiveClass {
  constructor({ accountId, items }) {
    super();

    this.accountId = accountId;
    this.$setAll({
      $dataLoaded: false,
      $dataLoading: false,
      $dataLoadingPromise: null,
    });
    if (items) this.$set('items', items);
  }

  get items() {
    return this._items;
  }

  set items(rawItems) {
    this._items = rawItems.map(itemData => new ModelAccountWalletBeneficialOwnersItem(itemData));
  }

  get actionRequiredItems() {
    return this.items.filter(item => !item.isStatusDocumentPending && !item.isStatusVerified);
  }

  get isSomeActionRequiredItems() {
    return Boolean(this.actionRequiredItems?.length);
  }

  get pendingItems() {
    return this.items.filter(item => item.isStatusDocumentPending);
  }

  get isSomePendingItems() {
    return Boolean(this.pendingItems?.length);
  }

  get notVerifiedItems() {
    return this.items.filter(item => !item.isStatusVerified);
  }

  get isAllItemsVerified() {
    return !this.notVerifiedItems.length;
  }

  static async fetchData(accountId) {
    return walletApi.getWalletActivationBeneficialOwnerList(accountId);
  }

  static async buildClass(accountId) {
    const items = await ModelAccountWalletBeneficialOwners.fetchData(accountId);
    return new ModelAccountWalletBeneficialOwners({ items, accountId });
  }

  async load() {
    if (this.$dataLoading) return this.$dataLoadingPromise;
    this.$dataLoading = true;
    try {
      this.$dataLoadingPromise = ModelAccountWalletBeneficialOwners.fetchData(this.accountId);
      this.items = await this.$dataLoadingPromise;
      this.$dataLoaded = true;
    } finally {
      this.$dataLoading = false;
    }
    return this.items;
  }

  update() {
    return this.load();
  }
}
